import React from "react";
import { GridColDef } from "@mui/x-data-grid";
import { Box, Chip, IconButton, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { AgreementProduct } from "@modules/agreements/types/agreementProduct";

export const useAgreementProductsListColumns = (
  refetch: () => void,
  translate: (key: string) => string,
  onEdit: (row: AgreementProduct) => void
) => {
  const columns: GridColDef<AgreementProduct>[] = [
    {
      field: "id",
      headerName: "ID",
      width: 80,
      sortable: true,
    },
    {
      field: "name",
      headerName: "Nome",
      flex: 1,
      minWidth: 200,
      sortable: true,
    },
    {
      field: "description",
      headerName: "Descrição",
      flex: 1,
      minWidth: 300,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ maxWidth: 300 }}>
          <Tooltip title={params.value || ""}>
            <span>{params.value || "Sem descrição"}</span>
          </Tooltip>
        </Box>
      ),
    },
    {
      field: "globalProductId",
      headerName: "ID Produto Global",
      width: 150,
      sortable: true,
    },
    {
      field: "globalProduct.name",
      headerName: "Nome Produto Global",
      width: 200,
      sortable: true,
      renderCell: (params) => (
        <span>{params.row.globalProduct?.name || "N/A"}</span>
      ),
    },
    {
      field: "isActive",
      headerName: "Status",
      width: 120,
      sortable: true,
      renderCell: (params) => (
        <Chip
          label={params.value ? "Ativo" : "Inativo"}
          color={params.value ? "success" : "default"}
          size="small"
        />
      ),
    },
    {
      field: "createdAt",
      headerName: "Data de Criação",
      width: 150,
      sortable: true,
      renderCell: (params) => (
        params.value ? new Date(params.value).toLocaleDateString("pt-BR") : "-"
      ),
    },
    {
      field: "actions",
      headerName: "Ações",
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ display: "flex", gap: 1 }}>
          <Tooltip title="Visualizar">
            <IconButton
              size="small"
              onClick={() => onEdit(params.row)}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Editar">
            <IconButton
              size="small"
              onClick={() => onEdit(params.row)}
            >
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Excluir">
            <IconButton
              size="small"
              color="error"
              onClick={() => {
                if (window.confirm("Tem certeza que deseja excluir este produto?")) {
                  // Implementar exclusão
                  refetch();
                }
              }}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  return columns;
};
